import { uploadSingleImage } from '../../../../utility/sb-api/sb-api.service';
import {
  closeModalSafely as closeModalSafelyBase,
  getTranslationsCollapsable as getTranslationsCollapsableBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  isEditMode,
  uploadImage,
  targetCategory,
  parentCategoryId,
  onSubmit,
  setIsSubmitting,
  setTargetCategory,
  closeModal,
  storeId,
) => {
  if (!errors?.length > 0) {
    setIsSubmitting(true);

    return (uploadImage
      ? uploadSingleImage(uploadImage, storeId).then((res) => res.id)
      : Promise.resolve(targetCategory?.coverImage?.id || null)
    ).then((imageId) =>
      handleSubmitBase(
        'item-categories',
        'editCategorySuccess',
        'editCategoryError',
        'createNewCategorySuccess',
        'createNewCategoryError',
        event,
        errors,
        {
          ...values,
          coverImageId: imageId,
          parentId: parentCategoryId || targetCategory?.parent?.id || null,
        },
        targetCategory,
        isEditMode,
        setIsSubmitting,
        setTargetCategory,
        closeModal,
        onSubmit,
        storeId,
      ),
    );
  } else {
    console.error('Got validation errors in ' + errors.join(', '));
  }
};

export const getTranslationsCollapsable = getTranslationsCollapsableBase;
